import { render, staticRenderFns } from "./Ligas.vue?vue&type=template&id=b4de4584&scoped=true"
import script from "./Ligas.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ligas.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Ligas.vue?vue&type=style&index=0&id=b4de4584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4de4584",
  null
  
)

export default component.exports